import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Logo from '../../components/global/Logo';

const useStyles = makeStyles(() => ({
  root: {
    height: 64,
  },
  logo: {
    height: 60,
  },
  avatar: {
    width: 60,
    height: 60
  }
}));

const TopBar = ({className, onMobileNavOpen, ...rest}) => {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      {...rest}
    >
      <Toolbar>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <Box flexGrow={1} />
        </Hidden>
        <RouterLink to="/">
          <Logo
            className={classes.logo}
          />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
